export const topicPrefix = "ap/fdata/";
export const imgTopicPrefix = "ap/imgdata/"

export const sitePhotoUrlPrefix = "https://s3-ap-southeast-1.amazonaws.com/station-image/";